export const V4_EMAIL_PAGE = 'onboarding/V4_EMAIL_PAGE'
export const V4_USER_PAGE = 'onboarding/V4_USER_PAGE'
export const V4_COMPANY_PAGE = 'onboarding/V4_COMPANY_PAGE'
export const V4_VERIFICATION_PAGE = 'onboarding/V4_VERIFICATION_PAGE'
